import { StudentService } from 'src/app/_services/student.service';
import { DataUtilService } from '../../_services/data-util.service';
import { QuizService } from '../../_services/quiz.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-new-quiz',
  templateUrl: './new-quiz.component.html',
  styleUrls: ['./new-quiz.component.css']
})
export class NewQuizComponent implements OnInit {
  subscriptionId=0
  learner:any =undefined
  creating=false
  server_student_user_id=0
  quiz_mode_name:string
  constructor(private route:ActivatedRoute,
    private quizService:QuizService,
    private router:Router,
    private dataUtilService:DataUtilService,
    private studentService:StudentService) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.subscriptionId = params['subscriptionId']
      this.quiz_mode_name = params['quiz_mode_name']

    });
   this.studentService.minStudentData.subscribe(
      x=>{
        this.learner=x
        this.server_student_user_id = this.learner.server_student_user_id
      }

    )
  }
  createQuiz(){
    this.creating=true
    if(this.subscriptionId!=0){
      this.quizService.createQuiz(this.subscriptionId,this.quiz_mode_name).subscribe(
        x=>{
          if(this.dataUtilService.isGoodResponse(x)){
            this.creating=false
            this.router.navigate(["/student/show", this.server_student_user_id])
          }
        }
      )
    }
  }
  cancelCreateQuiz(){
    this.router.navigate(["/student/show", this.server_student_user_id])
  }
}
